import palette from '../palette';

export default {
  styleOverrides: {
    root: {
      fontSize: '18px',
      fontWeight: 'normal',
      borderBottom: `1px solid ${palette.divider}`
    }
  }
};
